import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  width: 100px;
`;
Wrapper.displayName = 'Wrapper';

export const Button = styled.button`
  border-radius: 2px;
  border: solid 1px ${({ theme }) => theme.buttons.custom.border};
  background-color: ${({ theme }) => theme.buttons.custom.background};
  color: ${({ theme }) => theme.buttons.custom.color};
  text-align: center;
  min-width: 89px;
  width: auto;
  height: 34px;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 500;
  padding: 4px;
  cursor: pointer;

`;
Button.displayName = 'Button';
